import { Outlet, NavLink } from 'react-router-dom'

/**
 * Stripped-down layout for consignee sessions: header + content + a
 * 3-tab bottom nav. No sidebar, no FAB, none of the owner UI primitives.
 */
export default function MomShell() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        paddingBottom: 'var(--nav-height-mobile)',
        background: 'var(--color-bg)',
      }}
    >
      <main>
        <Outlet />
      </main>
      <nav
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: 'var(--nav-height-mobile)',
          background: 'var(--color-surface)',
          borderTop: '1px solid var(--color-border)',
          display: 'flex',
          paddingBottom: 'env(safe-area-inset-bottom, 0)',
          zIndex: 10,
        }}
      >
        {[
          { to: '/mom', label: 'Inventory', icon: '📦', end: true },
          { to: '/mom/sales', label: 'Sales', icon: '💵', end: false },
          { to: '/mom/settings', label: 'Settings', icon: '⚙', end: false },
        ].map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            style={({ isActive }) => ({
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 'var(--space-1)',
              color: isActive ? 'var(--color-primary)' : 'var(--color-text-faint)',
              fontWeight: isActive ? 600 : 400,
              fontSize: 'var(--font-size-xs)',
              textDecoration: 'none',
            })}
          >
            <span style={{ fontSize: '1.25rem' }}>{tab.icon}</span>
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
